import Icon from '../components/Icon.vue'

Icon.register({
  dna: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0.1 494.1c5.2-42.9 31.4-153.9 159.9-238.1-128.6-84.2-154.7-195.2-159.9-238.1-1.1-9.5 6.4-17.8 16-17.8l32.3-0.1c8.1-0.1 14.9 5.9 16 13.9 0.7 5 1.8 11.1 3.4 18.1h312.4c1.6-7 2.7-13.2 3.4-18.1 1.1-8 7.9-13.9 16-13.9l32.4 0.1c9.6 0 17 8.3 15.9 17.8-5.8 47.9-37.4 181.2-209.5 266.7-31.7 15.8-57.4 33.3-78.7 51.4h127.6c-5.6-4.8-10.8-9.6-17-14.2 21.4-11.2 40.9-23 58.5-35.4 93.3 78.7 114.3 169.8 118.9 207.7 1.2 9.5-6.3 17.8-15.9 17.8l-32.3 0.1c-8.1 0.1-14.9-5.9-16-13.9-0.6-4.9-1.9-11.2-3.5-18.1h-312.3c-1.6 7-2.7 13.2-3.4 18.1-1.1 8-7.9 13.9-16 13.9l-32.3-0.1c-9.6 0-17-8.3-15.9-17.8zM224 219.6c25.1-13.6 46.4-28.4 64.2-43.6h-128.5c17.9 15.2 39.2 29.9 64.3 43.6zM355.1 96h-262.1c5.7 10.4 12.7 21.1 21 32h220.1c8.2-10.9 15.2-21.6 21-32zM92.9 416h261.6c-5.8-10.4-12.9-21.1-21.2-32h-219.4c-8.2 10.9-15.2 21.6-21 32z'
      }
    ]
  }
})
